// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__16ejW","card":"Cards_card__2ipL6","infected":"Cards_infected__15iTs","recovered":"Cards_recovered__dBDtz","deaths":"Cards_deaths__1Pa6L"};